export const AD_REGENERATE_ATTEMPT_MAX = 3;
